window.HSMotionChapters = [
  {
    id: 'hero',
    label: '01 Lineup',
    progress: [0, 0.10],
    video: [0, 1.15],
    align: 'left',
    mobile: 'bottom',
    kicker: 'Holy Strips',
    title: 'Five tins. One daily ritual.',
    body: 'Dissolvable vitamins for energy, glow, sleep and the everyday basics.'
  },
  {
    id: 'd3',
    label: '02 Vitamin D3+K2',
    progress: [0.10, 0.22],
    video: [1.15, 3.0],
    align: 'left',
    mobile: 'bottom',
    kicker: '',
    title: 'Sunshine, shelf-stable.',
    body: 'Supports bone and vascular health.'
  },
  {
    id: 'b12',
    label: '03 Vitamin B12',
    progress: [0.22, 0.36],
    video: [3.0, 5.0],
    align: 'left',
    mobile: 'top',
    kicker: '',
    title: 'Designed for your daily ritual.',
    body: 'Open the tin. Take a strip. Go.'
  },
  {
    id: 'multi',
    label: '04 Multivitamin',
    progress: [0.36, 0.48],
    video: [5.0, 7.0],
    align: 'left',
    mobile: 'bottom',
    kicker: '',
    title: 'One strip. Once a day.',
    body: ''
  },
  {
    id: 'peel',
    label: '05 Hold',
    progress: [0.48, 0.62],
    video: [7.0, 9.2],
    align: 'left',
    mobile: 'top',
    kicker: '',
    title: 'No pills. No water.',
    body: 'Just place, dissolve and go.'
  },
  {
    id: 'dissolve',
    label: '06 Take',
    progress: [0.62, 0.76],
    video: [9.2, 11.5],
    align: 'left',
    mobile: 'bottom',
    kicker: '',
    title: 'Fast-dissolving. Ten seconds.',
    body: ''
  },
  {
    id: 'sleep',
    label: '07 Melatonin',
    progress: [0.76, 0.86],
    video: [11.5, 13.0],
    align: 'left',
    mobile: 'top',
    kicker: '',
    title: 'Lights out in ten seconds.',
    body: 'Natural peppermint. The low, effective dose.'
  },
  {
    id: 'finale',
    label: '08 Full range',
    progress: [0.86, 1],
    video: [13.0, 14.95],
    align: 'left',
    mobile: 'bottom',
    kicker: 'Holy Strips',
    title: 'The ritual that actually fits.',
    body: '',
    cta: true
  }
];

window.HSMotionHold = 0.12;
window.HSMotionLerp = 0.085;
window.HSMotionDuration = 14.95;
